<div class="ask">
  <div class="container">
    <div class="ask__header" *ngIf="title && askList.length">Someone Asked</div>
    <app-my-carousel-swiper *ngIf="!loading" [config]="carouselOptions">
      <div class="swiper-slide" *ngFor="let i of askList">
        <div class="ask__my-card" (click)="viewAsk(ViewAsk, i.message, i)">
          <div class="message">"{{ i.message | truncate : (width > 767 ? 65 : 45) }}"</div>
          <div class="footer">
            <div class="user">
              <img loading="lazy" src="{{ i.profileImage }}" alt="" />
              {{ i.appUser?.profileCharacterName | truncate : (width > 767 ? 15 : 8) }}
            </div>
            <div class="date">
              {{ i.createdAt }}
            </div>
          </div>
        </div>
      </div>
    </app-my-carousel-swiper>
  </div>
</div>

<ng-template #askPopup let-modal>
  <div class="modal-body">
    <div class="d-flex justify-content-between">
      <h2>Ask</h2>
      <img loading="lazy" src="../../../../assets/images/close-icon.svg" alt="img" (click)="modal.dismiss('Cross click')" />
    </div>
    <div class="referral-link">
      <section class="m-4">
        <div class="form-group">
          <textarea class="form-control" placeholder="Enter Your Question" id="exampleFormControlTextarea1" maxlength="500" [(ngModel)]="askMsg" rows="6"></textarea>
        </div>
      </section>
      <div class="mt-4">
        <div class="cart_btn">
          <button class="com_btn add-review-btn px-2" (click)="submitAsk()">Save <i class="fa fa-thumbs-up" aria-hidden="true"></i></button>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #ViewAsk let-modal>
  <div id="ask_detail_modal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="ask-modal">
      <div class="ask-modal__close" (click)="modal.dismiss('Cross click')">
        <i class="fa-solid fa-times"></i>
      </div>
      <div class="ask-modal__title">
        <i class="fa-solid fa-question-circle"></i> Ask
        <ng-container *ngIf="ask.id != null">
          <div class="options" style="position: absolute; right: 20px; top: 20px">
            <div class="icon" aria-hidden="true" id="list-new" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              <i class="fa fa-ellipsis-v"></i>
            </div>
            <div class="dropdown-menu" aria-labelledby="list-new">
              <a class="dropdown-item" *ngIf="ask?.userId == appUserId || roleService?.roles?.users?.includes('MEMBER_ASK')" (click)="deleteAsk(ask.id)"><i class="fa-solid fa-trash"></i> Delete</a>
              <!-- <a class="dropdown-item"><i class="fa-solid fa-lightbulb"></i> Suggest</a> -->
              <a class="dropdown-item" (click)="hideAsk(ask.id)"><i class="fa-solid fa-flag"></i> Report ({{ ask.hiddenBy.length }})</a>
            </div>
          </div>
        </ng-container>
      </div>
      <div class="ask-modal__question">
        <img loading="lazy" src="{{ ask.profileImage }}" style="width: 120px" alt="" />
        <div class="body">
          <div class="body__header">
            <div class="name">{{ ask.appUser?.profileCharacterName }}</div>
          </div>
          <div class="body__msg">"{{ askMsg }}"</div>
          <div class="meta">
            <div class="date"><i class="fa-regular fa-clock"></i> {{ ask.createdAt }}</div>
            <div class="like">
              <i (click)="likeForum(ask.id, ask)" class="i fa-{{ hasCheckedForum(ask.memberShopAskLikes) ? 'solid' : 'regular' }} fa-heart"></i>
              {{ ask.memberShopAskLikes.length }}
            </div>
          </div>
        </div>
      </div>
      <app-ask-forum [ask]="ask"></app-ask-forum>
    </div>
  </div>
</ng-template>
